import React from 'react';

export const App = () => {
  return (
    <a href="/contact-us/ask-va" rel="noreferrer noopener">
      Contact us online through Ask VA
    </a>
  );
};

export default App;
